<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-07 17:27:53
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-02-08 16:05:56
 * @name: 订单管理
 * @Description: 订单管理
 * @FilePath: \preSaleNafterSaleBackstage\src\views\approvalListManage\orderApprovalListManage.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <layout-normal>
    <table-search-form title="订单列表">
      <template v-slot:searchForm>
        <div class="search-form">
          <div class="search-line">
            <div class="search-label"><font>搜索</font></div>
            <div class="search-content">
              <el-input
                size="mini"
                v-model="searchForm.search"
                placeholder="请输入琴行名称、发起人、订单编号"
                @blur="setFocus()"
                @keyup.native.enter="onQuery"
              ></el-input>
            </div>
          </div>
          <div class="search-line">
            <div class="search-label"><font>当前状态</font></div>
            <div class="search-content">
              <div class="search-checkbox-group">
                <el-radio-group
                  size="mini"
                  v-model="searchForm.status"
                  @change="setFocus()"
                >
                  <el-radio-button
                    v-for="item of orderApproval.statusList"
                    :key="item.id"
                    :label="item.id"
                  >
                    {{ item.name }}
                  </el-radio-button>
                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="btn-group">
            <el-button
              size="mini"
              icon="el-icon-search"
              type="primary"
              id="filterSearch"
              @keyup.enter="onQuery"
              @click="onQuery"
              >搜索</el-button
            >
            <el-button
              size="mini"
              icon="el-icon-refresh"
              plain
              @click="initData()"
              >刷新</el-button
            >
          </div>
        </div>
      </template>
      <template v-slot:table>
        <el-table
          size="mini"
          :data="orderApproval.table_order_data.list"
          v-loading="loading"
          tooltip-effect="light"
          element-loading-text="数据加载中"
          fit
          :header-cell-style="{
            'background-color': $scssVars['Vars-background-bar-normal'],
            color: '#666',
          }"
          :style="{ fontSize: $scssVars['Vars-font-content-size'] }"
        >
          <el-table-column
            align="center"
            prop="id"
            label="ID"
            width="100"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="order_no"
            label="订单号"
            width="200"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="agency.agency_name"
            label="琴行名称"
            width="200"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="agency_user.realname"
            label="下单人"
            width="120"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="agency_user.mobile"
            label="琴行电话"
            width="120"
          ></el-table-column>
          <el-table-column align="center" label="商品信息" width="380">
            <template slot-scope="scope">
              <div class="goods">
                <font v-for="(item, index) of scope.row.goods" :key="index">{{
                  item.goods_name
                }}</font>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="total_price"
            label="金额"
            width="120"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="payed_price"
            label="实际支付"
            width="120"
          ></el-table-column>
          <el-table-column align="center" label="收货信息" width="300">
            <template slot-scope="scope">
              <font>{{
                scope.row.address.province +
                scope.row.address.city +
                scope.row.address.region +
                scope.row.address.detail
              }}</font>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="order_status"
            label="订单状态"
            width="120"
          ></el-table-column>
        </el-table>
      </template>
      <template v-slot:pagination>
        <Pagination
          class="pagination"
          v-if="pagination.page"
          :page.sync="pagination.page"
          :page-size.sync="pagination.limit"
          :total="orderApproval.table_order_data.total"
        >
        </Pagination>
      </template>
    </table-search-form>
  </layout-normal>
</template>
<script>
import tableSearchForm from "@/components/public/table-search-form.vue";
import orderApproval from "@/object/approvalList/orderApproval.class.js";
import { debounceation } from '@/utils/decorator';

export default {
  name: "orderApprovalListManage",
  components: {
    tableSearchForm,
  },
  data() {
    return {
      orderApproval: new orderApproval(),
      searchForm: {},
      loading: false,
      pagination: {}, //分页器信息
    };
  },
  watch: {
    //分页数据发送变化查询表格数据
    pagination: {
      handler(nv, ov) {
        nv.page && this.getTableData();
      },
      immediate: true,
      deep: true,
    },
  },
  activated() {
    this.initData(); //初始化数据
    this.refresh();
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 刷新页面
     */
    refresh() {
      this.orderApproval.getStatusList();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化数据
     */
    @debounceation(300)
    initData() {
      this.initSearchForm(); //初始化搜索条件表单
      this.initPagination(); //初始化分页信息
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 置焦点于搜索框
     */
    setFocus() {
      document.getElementById("filterSearch").focus();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击搜索框
     */
    @debounceation(300)
    onQuery() {
      this.initPagination();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化搜索条件表单
     */
    initSearchForm() {
      this.searchForm = {
        search: "",
        status: "",
      };
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化分页信息
     */
    initPagination() {
      this.pagination = {
        page: 1,
        limit: 10,
      };
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取表格数据
     */
    getTableData() {
      let params = { ...this.searchForm, ...this.pagination };
      this.loading = true;
      this.orderApproval.getTableData(params).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.goods {
  @include grid-row(auto-fill, auto);
  font {
    font-size: $Vars-font-content-size;
    &:not(:last-child)::after {
      content: '，';
    }
  }
}
</style>